import { Link, useNavigate } from 'react-router-dom';
import { Settings as SettingsIcon, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import ThemeToggle from './ThemeToggle';
import NotificationBell from './NotificationBell';
import Logo from './Logo';
import { toast } from 'sonner';

const Navbar = ({ isDashboard = false }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/signin');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b hidden md:block" style={{ background: 'var(--bg-secondary)', borderColor: 'var(--border-color)' }}>
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to={user ? '/dashboard' : '/'} className="flex items-center space-x-2 group">
              <Logo size="default" showText={true} />
            </Link>

            {/* Navigation Links */}
            <div className="flex items-center space-x-6">
              {isDashboard && user ? (
                <>
                  <Link to="/dashboard" className="text-gray-300 hover:text-purple-400 transition-colors">
                    Dashboard
                  </Link>
                  <Link to="/trading" className="text-gray-300 hover:text-purple-400 transition-colors">
                    Trading
                  </Link>
                  <Link to="/swap" className="text-gray-300 hover:text-purple-400 transition-colors">
                    Swap
                  </Link>
                  <Link to="/wallet" className="text-gray-300 hover:text-purple-400 transition-colors">
                    Wallet
                  </Link>
                  <Link to="/profile" className="text-gray-300 hover:text-purple-400 transition-colors">
                    Profile
                  </Link>
                  <div className="ml-4 pl-4 border-l border-purple-500/30 flex items-center space-x-2">
                    <NotificationBell />
                    <ThemeToggle />
                    <Link
                      to="/settings"
                      aria-label="Open settings"
                      className="p-2 rounded-full text-gray-300 hover:text-white hover:bg-white/5 transition-colors focus:outline-none focus-visible:outline-none"
                      data-testid="navbar-settings-link"
                    >
                      <SettingsIcon className="h-5 w-5" />
                    </Link>
                    <Button 
                      onClick={handleLogout}
                      className="flex items-center space-x-2 bg-red-600/20 hover:bg-red-600/30 border border-red-500/30 text-red-400 hover:text-red-300"
                    >
                      <LogOut className="h-4 w-4" />
                      <span>Logout</span>
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <ThemeToggle />
                  <Link to="/signin">
                    <Button variant="ghost" className="text-white hover:text-purple-400">
                      Sign In
                    </Button>
                  </Link>
                  <Link to="/signup">
                    <Button className="neo-btn neo-btn-primary font-semibold px-6">
                      Get Started
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>
  );
};

export default Navbar;
